import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { ProductField } from '@/@vxapp/@Enums/PHP/ServicesV2/Products/DataProviders/ProductField'

export const ProductsTableActions = [
  {
    id: 'edit',
    title: 'Edit',
    tooltip: 'Edit Product',
    icon: 'tabler-pencil',
    color: 'primary',
    disabled: false,
    hidden: false,
    emit: 'edit',
  },
  {
    id: 'preview',
    title: 'Preview',
    tooltip: 'View Product',
    icon: 'tabler-eye',
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Products.Preview.Name || '',
      paramKey: 'guid',
      itemKey: ProductField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
] as const satisfies readonly TableActionSpec[]
